import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";

const WalletConfigModalForm = ({
  setOpenWalletConfigModal,
  getUser,
  user,
}) => {
  const [limit, setLimit] = useState();
  const [flags, setFlags] = useState([
    { id: 1, name: "Allow subscription creation and renewal from wallet", value: "allow_wallet_only", checked: false },
    { id: 2, name: "Allow subscription creation and renewal from wallet with negative balance", value: "allow_negative_wallet", checked: false },
  ]);
  const [loading, setLoading] = useState(false);

  const cancel = () => {
    setLimit();
    setOpenWalletConfigModal(false);
  };

  useEffect(() => {
    if (user && user?.config) {
      setFlags(flags.map(f => {
        return {
          ...f,
          checked: user.config[f.value]
        }
      }))
      if (user?.config?.allow_negative_wallet) {
        setLimit(+user.config.credit_limit / 100)
      }
    } else {
      setLimit()
    }
  }, [user]);

  const onSubmit = () => {
    setLoading(true);
    const flagMap = Object.fromEntries(
      flags.map(f => [f.value, f.checked])
    );
    axios.put(`${process.env.REACT_APP_API_URL}/user/${user.id}/config`, {
      ...flagMap,
      credit_limit: limit * 100
    })
      .then(() => {
        toast.success("Wallet configuration have been updated successfully");
        getUser();
        cancel();
        setLoading(false);
      })
      .catch((err) => {
        if (err && err.response && err.response?.data && err.response?.data?.message) {
          toast.error(err.response.data.message);
        } else {
          toast.error("Technical Error, Please Try Again");
        }
        setLoading(false);
      });
  }

  return (
    <>
      <div
        className="d-flex flex-column scroll-y me-n7 pe-3"
        id="kt_modal_add_user_scroll"
        data-kt-scroll="true"
        data-kt-scroll-activate="{default: false, lg: true}"
        data-kt-scroll-max-height="auto"
        data-kt-scroll-dependencies="#kt_modal_add_user_header"
        data-kt-scroll-wrappers="#kt_modal_add_user_scroll"
        data-kt-scroll-offset="300px"
      >
        <div className="mt-2 d-flex flex-column gap-3">
          {
            flags.map((el, index) => (
              <div className="form-check form-check-custom form-check-solid" key={index}>
                <input
                  className="form-check-input"
                  type="checkbox"
                  value={el.value}
                  id={el.value}
                  checked={el.checked}
                  onChange={(e) => {
                    const checked = e.target.checked;
                    setFlags((prev) =>
                      prev.map((el) => {
                        if (el.value === e.target.value) {
                          return { ...el, checked };
                        }
                        return el;
                      })
                    );
                  }}
                />
                <label
                  className="form-check-label fs-5 fw-bold text-dark"
                  htmlFor={el.value}
                >
                  {el.name}
                </label>
              </div>
            ))
          }
        </div>
        <div className="fv-row mt-5">
          <label className="form-label fs-5 fw-bold">Wallet negative balance limit <br /> (Maximum negative balance allowed to complete the subscription creation and renewal)</label>
          <input
            onWheel={(e) => e.target.blur()}
            data-kt-user-table-filter="search"
            className="form-control form-control-solid w-100"
            placeholder="Enter Wallet Negative Balance Limit"
            disabled={!flags.find((item) => item.value === 'allow_negative_wallet').checked}
            value={limit}
            onChange={(e) => {
               const newValue = e.target.value
              const regex = /^(-?[0-9]\d*(\.)?(\d{1,2})?)$/
              const isValidValue = regex.test(newValue)

              if (isValidValue || e.target.value === '') {
                setLimit(e.target.value)
              }
            }}
          />
        </div>
      </div>
      <div className="text-center pt-15">
        <button
          type="reset"
          onClick={() => cancel()}
          className="btn btn-light mx-3"
          data-kt-users-modal-action="cancel"
        >
          Discard
        </button>

        <button
          type="submit"
          className="btn"
          data-kt-users-modal-action="submit"
          style={{ background: "#ffa459", color: "#fff" }}
          disabled={(flags.find((item) => item.value === 'allow_negative_wallet').checked && !limit) || loading}
          onClick={onSubmit}
        >
          <span className="indicator-label">{loading ? "Please wait..." : "Submit"}</span>
        </button>
      </div>
    </>
  );
};

export { WalletConfigModalForm };
